import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "../../../../../../Utils/drilldownData";

const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  sectionName: string,
  idx1: number,
  idx2: number
): ModuleFields[] => {
  const iataicaoKey = sectionName === "istanbul-sabiha-gokcen-airport" ? "IATA:SAW, ICAO LTFJ" : "IATA/ICAO code";
  const iataicaolabel = sectionName === "istanbul-sabiha-gokcen-airport" ? "IATA/SAW ICAO LTFJ" : "IATA/ICAO code";

  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [
      {
        fieldName: `Title (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].title`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].title`,
        formType: "input",
        label: `Title (${lang.code})`,
        placeholder: `Select Title ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Title ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      // {
      //   fieldName: `Key (${lang.code})`,
      //   fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].key`,
      //   parseField: lang.parseField,
      //   className: "col-span-6",
      //   type: "text",
      //   name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].key`,
      //   formType: "input",
      //   label: `Key (${lang.code})`,
      //   placeholder: `Select Key ${lang.code} ${sectionName}`,
      //   validation:
      //     lang.parseField === "field_content_english"
      //       ? { required: `Key ${lang.code} ${sectionName} is required` }
      //       : undefined,
      //   hidden: true
      // },
      {
        fieldName: `${iataicaoKey} (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.${iataicaoKey}`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.${iataicaolabel}`,
        formType: "input",
        label: `${iataicaoKey} (${lang.code})`,
        placeholder: `Enter ${iataicaoKey} ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `${iataicaoKey} ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Elevation (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Elevation`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Elevation`,
        formType: "input",
        label: `Elevation (${lang.code})`,
        placeholder: `Enter Elevation ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Elevation ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Runway (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Runway`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Runway`,
        formType: "input",
        label: `Runway (${lang.code})`,
        placeholder: `Enter Runway ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Runway ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Latitude (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Latitude`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Latitude`,
        formType: "input",
        label: `Latitude (${lang.code})`,
        placeholder: `Enter Latitude ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Latitude ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Longitude (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Longitude`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Longitude`,
        formType: "input",
        label: `Longitude (${lang.code})`,
        placeholder: `Enter Longitude ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Longitude ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Capacity (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Capacity`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].metrics.Capacity`,
        formType: "input",
        label: `Capacity (${lang.code})`,
        placeholder: `Enter Capacity ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Capacity ${lang.code} ${sectionName} is required` }
            : undefined,
      },
      {
        fieldName: `Descriptions (${lang.code})`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].descriptions`,
        parseField: lang.parseField,
        className: "col-span-12",
        type: "content",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].descriptions`,
        formType: "richText",
        label: `Descriptions (${lang.code})`,
        placeholder: `Enter Descriptions ${lang.code} ${sectionName}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Descriptions ${lang.code} ${sectionName} is required` }
            : undefined,
      },
    ];

    if (lang.parseField === "field_content_english") {
      fields.unshift({
        fieldName: `Image`,
        fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].image`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].image`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image ${sectionName}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Image ${sectionName} is required` } : undefined,
      });
    }

    return fields;
  });
};

const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];

let url = `/api/page-content/all-fields?pageName=about-us/corporate-profile/our-airports`;

export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;

const fetchAirportsData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;
    const fields1 =
      profileData?.[0]?.field_content_english?.data?.items?.[0]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 0, index)
      ) || [];
    const fields2 =
      profileData?.[0]?.field_content_english?.data?.items?.[1]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 1, index)
      ) || [];
    const fields3 =
      profileData?.[0]?.field_content_english?.data?.items?.[2]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 2, index)
      ) || [];
    const fields4 =
      profileData?.[0]?.field_content_english?.data?.items?.[3]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 3, index)
      ) || [];
    return {
      internationalOurAirports: fields1 as ModuleFields[],
      domesticOurAirports: fields2 as ModuleFields[],
      stolportsOurAirports: fields3 as ModuleFields[],
      overseasOurAirports: fields4 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};

export const getOurAirportsDrillDownData = async () => {
  if (!getData) {
    getData = await fetchAirportsData();
  }
  return getData;
};

// export const drilldownDataCorporatePolicies: { [key in ModuleConfig]: ModuleFields[] } = {
//   klInternationalAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[0].tabData.items[0].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForKlInternationalAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForKlInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForKlInternationalAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForKlInternationalAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForKlInternationalAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[0].tabData.items[0].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForKlInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[0].tabData.items[0].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForKlInternationalAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForKlInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForKlInternationalAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForKlInternationalAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForKlInternationalAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[0].tabData.items[0].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForKlInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForKlInternationalAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForKlInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForKlInternationalAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForKlInternationalAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForKlInternationalAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForKlInternationalAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForKlInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   kotaKinabaluInternationalAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[0].tabData.items[1].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForKotaKinabaluInternationalAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[0].tabData.items[1].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForKotaKinabaluInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[0].tabData.items[1].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForKotaKinabaluInternationalAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[0].tabData.items[1].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForKotaKinabaluInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForKotaKinabaluInternationalAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForKotaKinabaluInternationalAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForKotaKinabaluInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   kuchingInternationalAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[0].tabData.items[2].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForKuchingInternationalAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForKuchingInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForKuchingInternationalAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForKuchingInternationalAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForKuchingInternationalAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[0].tabData.items[2].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForKuchingInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[0].tabData.items[2].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForKuchingInternationalAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForKuchingInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForKuchingInternationalAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForKuchingInternationalAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForKuchingInternationalAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[0].tabData.items[2].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForKuchingInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForKuchingInternationalAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForKuchingInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForKuchingInternationalAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForKuchingInternationalAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForKuchingInternationalAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForKuchingInternationalAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForKuchingInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   langkawiInternationalAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[0].tabData.items[3].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLangkawiInternationalAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[0].tabData.items[3].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLangkawiInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[0].tabData.items[3].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLangkawiInternationalAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[0].tabData.items[3].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLangkawiInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLangkawiInternationalAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLangkawiInternationalAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLangkawiInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   penangInternationalAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[0].tabData.items[4].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForPenangInternationalAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the Image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForPenangInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForPenangInternationalAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForPenangInternationalAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForPenangInternationalAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForPenangInternationalAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForPenangInternationalAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[0].tabData.items[4].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForPenangInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions is required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[0].tabData.items[4].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForPenangInternationalAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the Image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForPenangInternationalAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForPenangInternationalAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForPenangInternationalAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForPenangInternationalAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForPenangInternationalAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[0].tabData.items[4].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForPenangInternationalAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[0].tabData.items[4].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForPenangInternationalAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions is required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       validation: { required: "Content for Malay Next Page Link is required" },
//     },
//   ],

//   melakaAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[0].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForMelakaAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForMelakaAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForMelakaAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForMelakaAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForMelakaAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForMelakaAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForMelakaAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[0].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForMelakaAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[0].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForMelakaAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForMelakaAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForMelakaAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForMelakaAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForMelakaAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForMelakaAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForMelakaAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[0].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForMelakaAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },

//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForMelakaAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForMelakaAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForMelakaAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForMelakaAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForMelakaAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForMelakaAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForMelakaAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForMelakaAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sultanAbdulAzizShahAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[1].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanAbdulAzizShahAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanAbdulAzizShahAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[1].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanAbdulAzizShahAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanAbdulAzizShahAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanAbdulAzizShahAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanAbdulAzizShahAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanAbdulAzizShahAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//     },
//   ],

//   sultanAbdulHalimAirportAlorSetar: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[2].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanAbdulHalimAirportAlorSetar",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[2].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanAbdulHalimAirportAlorSetar",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[2].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanAbdulHalimAirportAlorSetar",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[2].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanAbdulHalimAirportAlorSetar",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanAbdulHalimAirportAlorSetar",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanAbdulHalimAirportAlorSetar",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[2].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanAbdulHalimAirportAlorSetar",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sultanAhmadShahAirportKuantan: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[3].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanAhmadShahAirportKuantan",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[3].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanAhmadShahAirportKuantan",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[3].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanAhmadShahAirportKuantan",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[3].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanAhmadShahAirportKuantan",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanAhmadShahAirportKuantan",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanAhmadShahAirportKuantan",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[3].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanAhmadShahAirportKuantan",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sultanAzlanShahAirportIpoh: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[4].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanAzlanShahAirportIpoh",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanAzlanShahAirportIpoh",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[4].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanAzlanShahAirportIpoh",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanAzlanShahAirportIpoh",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[4].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanAzlanShahAirportIpoh",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanAzlanShahAirportIpoh",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanAzlanShahAirportIpoh",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sultanIsmailPetraAirportKotaBharu: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[5].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanIsmailPetraAirportKotaBharu",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[5].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanIsmailPetraAirportKotaBharu",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[5].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanIsmailPetraAirportKotaBharu",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[5].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanIsmailPetraAirportKotaBharu",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanIsmailPetraAirportKotaBharu",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanIsmailPetraAirportKotaBharu",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[5].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanIsmailPetraAirportKotaBharu",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sultanMahmudAirportKualaTerengganu: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[6].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSultanMahmudAirportKualaTerengganu",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[6].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSultanMahmudAirportKualaTerengganu",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[6].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSultanMahmudAirportKualaTerengganu",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[6].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSultanMahmudAirportKualaTerengganu",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSultanMahmudAirportKualaTerengganu",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSultanMahmudAirportKualaTerengganu",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[6].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSultanMahmudAirportKualaTerengganu",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   bintuluAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[7].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForBintuluAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForBintuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForBintuluAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForBintuluAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForBintuluAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForBintuluAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForBintuluAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[7].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForBintuluAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[7].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForBintuluAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForBintuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForBintuluAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForBintuluAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForBintuluAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForBintuluAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForBintuluAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[7].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForBintuluAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForBintuluAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForBintuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForBintuluAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForBintuluAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForBintuluAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForBintuluAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForBintuluAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[7].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForBintuluAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   limbangAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[8].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLimbangAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLimbangAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLimbangAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLimbangAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLimbangAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLimbangAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLimbangAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[8].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLimbangAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[8].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLimbangAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLimbangAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLimbangAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLimbangAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLimbangAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLimbangAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLimbangAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[8].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLimbangAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLimbangAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLimbangAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLimbangAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLimbangAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLimbangAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLimbangAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLimbangAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[8].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLimbangAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   miriAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[9].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForMiriAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForMiriAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForMiriAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForMiriAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForMiriAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForMiriAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForMiriAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[9].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForMiriAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[9].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForMiriAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForMiriAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForMiriAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForMiriAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForMiriAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForMiriAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForMiriAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[9].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForMiriAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForMiriAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForMiriAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForMiriAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForMiriAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForMiriAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForMiriAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForMiriAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[9].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForMiriAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   muluAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[10].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForMuluAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForMuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForMuluAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForMuluAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForMuluAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForMuluAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForMuluAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[10].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForMuluAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[10].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForMuluAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForMuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForMuluAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForMuluAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForMuluAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForMuluAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForMuluAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[10].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForMuluAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForMuluAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForMuluAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForMuluAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForMuluAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForMuluAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForMuluAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForMuluAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[10].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForMuluAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   mukahAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[11].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForMukahAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForMukahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForMukahAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForMukahAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForMukahAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForMukahAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForMukahAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[11].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForMukahAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[11].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForMukahAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForMukahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForMukahAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForMukahAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForMukahAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForMukahAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForMukahAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[11].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForMukahAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForMukahAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForMukahAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForMukahAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForMukahAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForMukahAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForMukahAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForMukahAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[11].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForMukahAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sibuAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[12].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSibuAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSibuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSibuAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSibuAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSibuAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSibuAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSibuAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[12].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSibuAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[12].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSibuAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSibuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSibuAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSibuAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSibuAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSibuAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSibuAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[12].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSibuAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSibuAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSibuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSibuAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSibuAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSibuAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSibuAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSibuAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[12].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSibuAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   labuanAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[13].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLabuanAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLabuanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLabuanAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLabuanAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLabuanAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLabuanAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLabuanAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[13].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLabuanAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[13].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLabuanAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLabuanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLabuanAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLabuanAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLabuanAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLabuanAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLabuanAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[13].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLabuanAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLabuanAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLabuanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLabuanAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLabuanAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLabuanAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLabuanAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLabuanAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[13].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLabuanAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   lahadDatuAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[14].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLahadDatuAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLahadDatuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLahadDatuAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLahadDatuAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLahadDatuAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[14].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLahadDatuAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[14].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLahadDatuAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLahadDatuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLahadDatuAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLahadDatuAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLahadDatuAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[14].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLahadDatuAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLahadDatuAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLahadDatuAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLahadDatuAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLahadDatuAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLahadDatuAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLahadDatuAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[14].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLahadDatuAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sandakanAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[15].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSandakanAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSandakanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSandakanAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSandakanAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSandakanAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSandakanAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSandakanAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[15].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSandakanAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[15].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSandakanAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSandakanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSandakanAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSandakanAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSandakanAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSandakanAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSandakanAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[15].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSandakanAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSandakanAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSandakanAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSandakanAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSandakanAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSandakanAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSandakanAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSandakanAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[15].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSandakanAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   tawauAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[1].tabData.items[16].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForTawauAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForTawauAirport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForTawauAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForTawauAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForTawauAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForTawauAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForTawauAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[1].tabData.items[16].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForTawauAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[1].tabData.items[16].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForTawauAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForTawauAirport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForTawauAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForTawauAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForTawauAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForTawauAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForTawauAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[1].tabData.items[16].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForTawauAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForTawauAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForTawauAirport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForTawauAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForTawauAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForTawauAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForTawauAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForTawauAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[1].tabData.items[16].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForTawauAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   pangkorStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[0].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForPangkorStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForPangkorStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForPangkorStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForPangkorStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForPangkorStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForPangkorStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForPangkorStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[0].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForPangkorStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[0].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForPangkorStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForPangkorStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForPangkorStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForPangkorStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForPangkorStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForPangkorStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForPangkorStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[0].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForPangkorStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   redangStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[1].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForRedangStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForRedangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForRedangStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForRedangStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForRedangStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForRedangStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForRedangStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[1].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForRedangStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[1].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForRedangStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForRedangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForRedangStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForRedangStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForRedangStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForRedangStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForRedangStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[1].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForRedangStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForRedangStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForRedangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForRedangStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForRedangStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForRedangStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForRedangStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForRedangStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[1].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForRedangStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],
//   tiomanStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[2].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForTiomanStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForTiomanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForTiomanStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForTiomanStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForTiomanStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForTiomanStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForTiomanStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[2].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForTiomanStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[2].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForTiomanStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForTiomanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForTiomanStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForTiomanStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForTiomanStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForTiomanStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForTiomanStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[2].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForTiomanStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForTiomanStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForTiomanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForTiomanStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForTiomanStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForTiomanStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForTiomanStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForTiomanStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[2].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForTiomanStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   bakelalanStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[3].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForBakelalanStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForBakelalanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForBakelalanStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForBakelalanStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForBakelalanStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForBakelalanStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForBakelalanStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[3].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForBakelalanStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[3].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForBakelalanStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForBakelalanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForBakelalanStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForBakelalanStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForBakelalanStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForBakelalanStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForBakelalanStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[3].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForBakelalanStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForBakelalanStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForBakelalanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForBakelalanStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForBakelalanStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForBakelalanStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForBakelalanStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForBakelalanStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[3].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForBakelalanStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//   ],

//   barioStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[4].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForBarioStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForBarioStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForBarioStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForBarioStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForBarioStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForBarioStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForBarioStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[4].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForBarioStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[4].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForBarioStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForBarioStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForBarioStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForBarioStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForBarioStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForBarioStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForBarioStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[4].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForBarioStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForBarioStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForBarioStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForBarioStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForBarioStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForBarioStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForBarioStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForBarioStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[4].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForBarioStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   belagaStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[5].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForBelagaStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForBelagaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForBelagaStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForBelagaStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForBelagaStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForBelagaStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForBelagaStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[5].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForBelagaStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[5].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForBelagaStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForBelagaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForBelagaStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForBelagaStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForBelagaStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForBelagaStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForBelagaStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[5].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForBelagaStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForBelagaStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForBelagaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForBelagaStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForBelagaStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForBelagaStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForBelagaStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForBelagaStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[5].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForBelagaStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   kapitStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[6].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForKapitStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForKapitStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForKapitStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForKapitStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForKapitStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForKapitStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForKapitStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[6].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForKapitStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[6].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForKapitStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForKapitStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForKapitStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForKapitStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForKapitStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForKapitStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForKapitStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[6].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForKapitStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForKapitStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForKapitStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForKapitStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForKapitStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForKapitStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForKapitStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForKapitStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[6].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForKapitStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   lawasStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[7].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLawasStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLawasStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLawasStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLawasStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLawasStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLawasStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLawasStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[7].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLawasStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[7].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLawasStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLawasStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLawasStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLawasStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLawasStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLawasStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLawasStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[7].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLawasStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLawasStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLawasStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLawasStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLawasStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLawasStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLawasStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLawasStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[7].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLawasStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longAkahStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[8].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongAkahStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongAkahStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongAkahStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongAkahStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongAkahStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongAkahStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongAkahStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[8].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongAkahStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[8].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongAkahStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongAkahStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongAkahStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongAkahStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongAkahStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongAkahStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongAkahStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[8].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongAkahStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongAkahStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongAkahStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongAkahStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongAkahStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongAkahStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongAkahStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongAkahStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[8].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongAkahStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longBangaStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[9].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongBangaStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongBangaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongBangaStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongBangaStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongBangaStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongBangaStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongBangaStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[9].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongBangaStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[9].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongBangaStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongBangaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongBangaStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongBangaStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongBangaStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongBangaStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongBangaStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[9].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongBangaStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongBangaStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongBangaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongBangaStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongBangaStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongBangaStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongBangaStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongBangaStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[9].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongBangaStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longLellangStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[10].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongLellangStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongLellangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongLellangStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the Latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongLellangStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the Elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongLellangStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the Longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongLellangStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the Runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongLellangStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the Capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[10].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongLellangStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the Descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[10].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongLellangStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongLellangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongLellangStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongLellangStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongLellangStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongLellangStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongLellangStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[10].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongLellangStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongLellangStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongLellangStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongLellangStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the Latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongLellangStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the Elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongLellangStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the Longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongLellangStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the Runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongLellangStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the Capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[10].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongLellangStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the Descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longSemadoStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[11].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongSemadoStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongSemadoStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongSemadoStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongSemadoStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongSemadoStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[11].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongSemadoStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[11].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongSemadoStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongSemadoStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongSemadoStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongSemadoStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongSemadoStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[11].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongSemadoStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongSemadoStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongSemadoStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongSemadoStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongSemadoStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongSemadoStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongSemadoStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[11].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongSemadoStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longSeridanStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[12].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongSeridanStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongSeridanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongSeridanStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongSeridanStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongSeridanStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[12].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongSeridanStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[12].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongSeridanStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongSeridanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongSeridanStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongSeridanStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongSeridanStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[12].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongSeridanStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongSeridanStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongSeridanStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongSeridanStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongSeridanStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongSeridanStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongSeridanStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[12].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongSeridanStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   marudiStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[13].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForMarudiStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForMarudiStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForMarudiStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForMarudiStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForMarudiStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForMarudiStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForMarudiStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[13].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForMarudiStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[13].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForMarudiStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForMarudiStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForMarudiStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForMarudiStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForMarudiStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForMarudiStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForMarudiStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[13].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForMarudiStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForMarudiStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForMarudiStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForMarudiStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForMarudiStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForMarudiStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForMarudiStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForMarudiStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[13].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForMarudiStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   kudatStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[14].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForKudatStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForKudatStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForKudatStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForKudatStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForKudatStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForKudatStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForKudatStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[14].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForKudatStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[14].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForKudatStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForKudatStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForKudatStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForKudatStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForKudatStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForKudatStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForKudatStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[14].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForKudatStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForKudatStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForKudatStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForKudatStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForKudatStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForKudatStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForKudatStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForKudatStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[14].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForKudatStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   longPasiaStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[15].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForLongPasiaStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForLongPasiaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter the IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForLongPasiaStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForLongPasiaStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForLongPasiaStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[15].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForLongPasiaStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[15].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForLongPasiaStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForLongPasiaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForLongPasiaStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForLongPasiaStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForLongPasiaStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[15].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForLongPasiaStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForLongPasiaStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForLongPasiaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter the IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForLongPasiaStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForLongPasiaStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForLongPasiaStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForLongPasiaStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[15].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForLongPasiaStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   sempornaStolport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[2].tabData.items[16].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForSempornaStolport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Enter the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForSempornaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (EN)",
//       placeholder: "Enter IATA/ICAO code",
//       validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForSempornaStolport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter the latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForSempornaStolport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter the elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForSempornaStolport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter the longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForSempornaStolport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter the runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForSempornaStolport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter the capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[2].tabData.items[16].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForSempornaStolport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter the descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },

//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[2].tabData.items[16].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForSempornaStolport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForSempornaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (MS)",
//       placeholder: "Enter IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForSempornaStolport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForSempornaStolport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForSempornaStolport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForSempornaStolport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForSempornaStolport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[2].tabData.items[16].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForSempornaStolport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },

//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForSempornaStolport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Enter the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA/ICAO code (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.IATA/ICAO code",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForSempornaStolport",
//       formType: "input",
//       label: "IATA/ICAO code (ZH)",
//       placeholder: "Enter IATA/ICAO code",
//       // validation: { required: "IATA/ICAO code is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForSempornaStolport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter the latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForSempornaStolport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter the elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForSempornaStolport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter the longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForSempornaStolport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter the runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForSempornaStolport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter the capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[2].tabData.items[16].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForSempornaStolport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter the descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],

//   istanbulSabihaGokcenAirport: [
//     {
//       fieldName: "Image (EN)",
//       fieldValue: "data.items[3].tabData.items[0].image",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_english_imageForIstanbulSabihaGokcenAirport",
//       formType: "file",
//       label: "Image (EN)",
//       placeholder: "Upload the image",
//       validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA:SAW, ICAO LTFJ (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.IATA:SAW, ICAO LTFJ",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_iataicaocodeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "IATA:SAW, ICAO LTFJ (EN)",
//       placeholder: "Enter IATA:SAW, ICAO LTFJ",
//       validation: { required: "IATA:SAW, ICAO LTFJ is required" },
//     },
//     {
//       fieldName: "Latitude (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_latitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Latitude (EN)",
//       placeholder: "Enter latitude",
//       validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_elevationForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Elevation (EN)",
//       placeholder: "Enter elevation",
//       validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_longitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Longitude (EN)",
//       placeholder: "Enter longitude",
//       validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Runway",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_runwayForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Runway (EN)",
//       placeholder: "Enter runway",
//       validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (EN)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_capacityForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Capacity (EN)",
//       placeholder: "Enter capacity",
//       validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (EN)",
//       fieldValue: "data.items[3].tabData.items[0].descriptions",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_descriptionsForIstanbulSabihaGokcenAirport",
//       formType: "richText",
//       label: "Descriptions (EN)",
//       placeholder: "Enter descriptions",
//       validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "English Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "English Next Page Name",
//       placeholder: "Enter content for English Next Page Name",
//       validation: { required: "Content for English Next Page Name is required" },
//     },
//     {
//       fieldName: "English Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "English Next Page Link",
//       placeholder: "Enter content for English Next Page Link",
//       validation: { required: "Content for English Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (MS)",
//       fieldValue: "data.items[3].tabData.items[0].image",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_malay_imageForIstanbulSabihaGokcenAirport",
//       formType: "file",
//       label: "Image (MS)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA:SAW, ICAO LTFJ (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.IATA:SAW, ICAO LTFJ",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_iataicaocodeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "IATA:SAW, ICAO LTFJ (MS)",
//       placeholder: "Enter IATA:SAW, ICAO LTFJ",
//       // validation: { required: "IATA:SAW, ICAO LTFJ is required" },
//     },
//     {
//       fieldName: "Latitude (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_latitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Latitude (MS)",
//       placeholder: "Enter latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_elevationForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Elevation (MS)",
//       placeholder: "Enter elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_longitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Longitude (MS)",
//       placeholder: "Enter longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Runway",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_runwayForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Runway (MS)",
//       placeholder: "Enter runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (MS)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_capacityForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Capacity (MS)",
//       placeholder: "Enter capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (MS)",
//       fieldValue: "data.items[3].tabData.items[0].descriptions",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_descriptionsForIstanbulSabihaGokcenAirport",
//       formType: "richText",
//       label: "Descriptions (MS)",
//       placeholder: "Enter descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Malay Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Malay Next Page Name",
//       placeholder: "Enter content for Malay Next Page Name",
//       // validation: { required: "Content for Malay Next Page Name is required" },
//     },
//     {
//       fieldName: "Malay Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Malay Next Page Link",
//       placeholder: "Enter content for Malay Next Page Link",
//       // validation: { required: "Content for Malay Next Page Link is required" },
//     },
//     {
//       fieldName: "Image (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].image",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "image",
//       name: "field_content_mandarin_imageForIstanbulSabihaGokcenAirport",
//       formType: "file",
//       label: "Image (ZH)",
//       placeholder: "Upload the image",
//       // validation: { required: "Image is required" },
//     },
//     {
//       fieldName: "IATA:SAW, ICAO LTFJ (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.IATA:SAW, ICAO LTFJ",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_iataicaocodeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "IATA:SAW, ICAO LTFJ (ZH)",
//       placeholder: "Enter IATA:SAW, ICAO LTFJ",
//       // validation: { required: "IATA:SAW, ICAO LTFJ is required" },
//     },
//     {
//       fieldName: "Latitude (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Latitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_latitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Latitude (ZH)",
//       placeholder: "Enter latitude",
//       // validation: { required: "Latitude is required" },
//     },
//     {
//       fieldName: "Elevation (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Elevation",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_elevationForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Elevation (ZH)",
//       placeholder: "Enter elevation",
//       // validation: { required: "Elevation is required" },
//     },
//     {
//       fieldName: "Longitude (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Longitude",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_longitudeForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Longitude (ZH)",
//       placeholder: "Enter longitude",
//       // validation: { required: "Longitude is required" },
//     },
//     {
//       fieldName: "Runway (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Runway",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_runwayForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Runway (ZH)",
//       placeholder: "Enter runway",
//       // validation: { required: "Runway is required" },
//     },
//     {
//       fieldName: "Capacity (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].metrics.Capacity",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_capacityForIstanbulSabihaGokcenAirport",
//       formType: "input",
//       label: "Capacity (ZH)",
//       placeholder: "Enter capacity",
//       // validation: { required: "Capacity is required" },
//     },
//     {
//       fieldName: "Descriptions (ZH)",
//       fieldValue: "data.items[3].tabData.items[0].descriptions",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_descriptionsForIstanbulSabihaGokcenAirport",
//       formType: "richText",
//       label: "Descriptions (ZH)",
//       placeholder: "Enter descriptions",
//       // validation: { required: "Descriptions are required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Name",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Mandarin Next Page Name",
//       placeholder: "Enter content for Mandarin Next Page Name",
//       // validation: { required: "Content for Mandarin Next Page Name is required" },
//     },
//     {
//       fieldName: "Mandarin Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Mandarin Next Page Link",
//       placeholder: "Enter content for Mandarin Next Page Link",
//       // validation: { required: "Content for Mandarin Next Page Link is required" },
//     },
//   ],
// };
